import axios from 'axios';

// --- CONFIGURATION CONSTANTS ---
const AUTH_STORAGE_KEY = 'salon_auth';
const BASE_API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000/api';

const axiosInstance = axios.create({
    baseURL: BASE_API_URL,
});

// --- HELPER FUNCTIONS ---
function getSession() {
    try {
        const sessionJson = localStorage.getItem(AUTH_STORAGE_KEY);
        return sessionJson ? JSON.parse(sessionJson) : null;
    } catch (e) {
        return null;
    }
}

function saveNewAccessToken(newAccessToken) {
    const session = getSession();
    if (session) {
        session.access_token = newAccessToken;
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
    }
}

// Global logout that clears everything
export function logoutUser() {
    localStorage.removeItem(AUTH_STORAGE_KEY);

    // localStorage.removeItem('adminUser'); 
    // localStorage.removeItem('currentStylist');
    window.location.href = '/authenticate';
}

// --- REQUEST INTERCEPTOR ---
axiosInstance.interceptors.request.use(
    (config) => {
        const session = getSession();
        if (session?.access_token) {
            config.headers.Authorization = `Bearer ${session.access_token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// --- RESPONSE INTERCEPTOR ---
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const session = getSession();

        // If 401 and we haven't retried yet
        if (error.response?.status === 401 && session?.refresh_token && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshResponse = await axios.post(`${BASE_API_URL}/auth/refresh`, null, {
                    headers: { 'Authorization': `Bearer ${session.refresh_token}` }
                });
                
                const newToken = refreshResponse.data.access_token;
                saveNewAccessToken(newToken);
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axios(originalRequest); 
            } catch (refreshError) {
                logoutUser();
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error.response?.data || error.message);
    }
);

export default axiosInstance;